import React from 'react';
import PropTypes from 'prop-types';
import dumbBem from 'dumb-bem';
import tx from 'transform-props-with';
import arrowLeft from 'images/arrow-left.svg';
import './NavBack.css';


const dumbNavBack = dumbBem('l-nav-back');
const NavBackWrp = tx(dumbNavBack)('div');

const Arrow = tx([{ element: 'arrow' }, dumbNavBack])('div');
const Label = tx([{ element: 'label' }, dumbNavBack])('div');


export const NavBack = ({
  onClick,
  children,
}) => {
  return (
    <NavBackWrp onClick={onClick} data-testid="button">
      <Arrow><img src={arrowLeft} alt="" /></Arrow>
      <Label>{children}</Label>
    </NavBackWrp>
  );
};

NavBack.propTypes = {
  onClick: PropTypes.func.isRequired,
  children: PropTypes.node.isRequired,
};

export default NavBack;



// WEBPACK FOOTER //
// ./src/components/landing/components/navBack/NavBack.js